import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import ColleagueWriterForm from '../forms/colleague-writer-form';
import { colleagueWriterValidationSchema } from '../schema/colleagueWriter.js';

export default function ColleagueWriterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Colleague Writer Node Details',
        altText: 'Colleague Writer Node',
        defaultLabel: 'Colleague Writer Node',
      }}
    >
      <CommonNode
        FormComponent={ColleagueWriterForm}
        schemaResolver={colleagueWriterValidationSchema}
      />
    </NodeProvider>
  );
}
